import React from "react";

const BodyTwo = props => {
  return <div className="body2">{props.text}</div>;
};

export default BodyTwo;
